import React from 'react';
import cn from 'classnames';
import { useNamedContainers } from '@alfa-bank/site-named-container/utils';

import type { TBenefitsBlockV2PropsDesktop } from '../models/desktop';

export const BenefitsBlockV2LayoutDesktop = ({
    Background,
    Block,
    backgroundColor = '#F2F3F5',
    children,
    className,
    contentStyler,
    dataTestId = 'benefit-block-v2',
    imgClassName,
    styles,
}: TBenefitsBlockV2PropsDesktop) => {
    const { buttons, headline, image, text, title } = useNamedContainers(children);

    return (
        <div className={cn(styles.wrapper, className)} data-test-id={dataTestId}>
            <Background
                className={cn(styles.external, styles.container)}
                color={backgroundColor}
                styler={{ borderRadius: 32, ...contentStyler }}
            >
                <Block className={cn(styles.external, styles.content)}>
                    {title && <Block notPadded>{title}</Block>}
                    {headline && (
                        <Block notPadded styler={{ marginTop: 24 }}>
                            {headline}
                        </Block>
                    )}
                    {text && (
                        <Block notPadded styler={{ marginTop: 8 }}>
                            {text}
                        </Block>
                    )}
                    {buttons && (
                        <Block notPadded styler={{ marginTop: 24 }}>
                            {buttons}
                        </Block>
                    )}
                </Block>

                {image && (
                    <Block
                        className={cn(styles.external, styles.imageBlock, imgClassName)}
                        notPadded
                    >
                        {image}
                    </Block>
                )}
            </Background>
        </div>
    );
};
